<template>
  <div class="start-page">
    <div v-if="loader" class="loader">
      <!-- <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner> -->
      <idx-skeleton-chart type="area" />
    </div>
    <div v-else>
      <highcharts :options="chartOptions"></highcharts>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import eventBus from '../../../../eventBus';

export default {
  name: 'AnswersEvolution',
  props: ['dataGraph', 'reportType', 'accumulated'],
  components: {
    idxSkeletonChart,
  },
  data: () => ({
    chartOptions: {},
    loader: true,
    legend: '',
    type: 'column',
    monthly: false,
    // reportType: 'day',
    isPanel: false,
  }),
  watch: {
    actionGroupData: function watchActionGroup() {
      this.prepareChart();
    },
    myActionId: function watchMyActionId() {
      this.prepareChart();
    },
    myActionsIds: function watchMyActionsIds() {
      this.prepareChart();
    },
    myIh1: function watchMyIh1() {
      this.prepareChart();
    },
    myHierarchies1: function watchMyHierarchies1(){
      this.prepareChart();
    },
    myIh2: function watchMyIh2() {
      this.prepareChart();
    },
    myHierarchies2: function watchMyHierarchies2(){
      this.prepareChart();
    },
    calendarDates: function watchDates() {
      this.prepareChart();
    },
    myMetric: function watchMyMetric() {
      this.prepareChart();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.prepareChart();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.prepareChart();
    },
  },
  computed: {
    ...mapState('charts', ['answersEvolution']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    ...mapActions('charts', [
      'evolutionDailyAnswers',
      'evolutionPeriodAnswers',
    ]),
    ...mapActions('calendar', ['setDefaultDates']),
    async prepareChart() {
      switch (this.reportType) {
        case 'day':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accDailyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.dailyLabel')}`;
          }
          await this.setColumns();
          break;
        case 'week':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accWeeklyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.weeklyLabel')}`;
          }
          await this.setColumnsPeriod();
          break;
        case 'month':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accMonthlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.monthlyLabel')}`;
          }
          await this.setColumnsPeriod();
          break;
        case 'quarter':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accQuarterlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.quarterlyLabel')}`;
          }
          await this.setColumnsPeriod();
          break;
        default:
          break;
      }
    },
    async setColumns() {
      this.loader = true;
      await this.evolutionDailyAnswers({
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        token: this.userAuth.token,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      });
      if (this.accumulated) {
        await this.renderChart({
          categories: this.answersEvolution.categories,
          series: this.answersEvolution.seriesAccumulated,
        });
      } else {
        await this.renderChart({
          categories: this.answersEvolution.categories,
          series: this.answersEvolution.series,
        });
      }
      this.loader = false;
    },

    async setColumnsPeriod() {
      this.loader = true;
      await this.evolutionPeriodAnswers({
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        token: this.userAuth.token,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
        reportType: this.reportType,
      });
      if (this.accumulated) {
        await this.renderChart({
          categories: this.answersEvolution.categories,
          series: this.answersEvolution.seriesAccumulated,
        });
      } else {
        await this.renderChart({
          categories: this.answersEvolution.categories,
          series: this.answersEvolution.series,
        });
      }

      this.loader = false;
    },

    async setColumnCard(data) {
      this.loader = true;
      if (this.reportType === 'day') {
        await this.evolutionDailyAnswers({
          companyId: this.userAuth.companyId,
          actionId: data.actionId ? data.actionId._id : null,
          token: this.userAuth.token,
          ih1: data.ih1 ? data.ih1._id : null,
          // startDate: '2022-06-12',
          // endDate: '2022-07-12',
          period: this.dataGraph.period,
          reportType: this.reportType ? this.reportType : 'month',
          metric: data.metric ? data.metric : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          indicator: data.indicator ? data.indicator : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
        })
          .then(async () => {
            if (this.accumulated) {
              this.renderChart({
                categories: this.answersEvolution.categories,
                series: this.answersEvolution.seriesAccumulated,
              });
            } else {
              this.renderChart({
                categories: this.answersEvolution.categories,
                series: this.answersEvolution.series,
              });
            }
          })
          .catch(() => {
            this.loader = false;
          });
      } else {
        await this.evolutionPeriodAnswers({
          companyId: this.userAuth.companyId,
          actionId: data.actionId ? data.actionId._id : null,
          token: this.userAuth.token,
          ih1: data.ih1 ? data.ih1._id : null,
          // startDate: '2022-06-12',
          // endDate: '2022-07-12',
          period: this.dataGraph.period,
          reportType: this.reportType ? this.reportType : 'month',
          metric: data.metric ? data.metric : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          indicator: data.indicator ? data.indicator : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
        });
        if (this.accumulated) {
          await this.renderChart({
            categories: this.answersEvolution.categories,
            series: this.answersEvolution.seriesAccumulated,
          });
        } else {
          await this.renderChart({
            categories: this.answersEvolution.categories,
            series: this.answersEvolution.series,
          });
        }
      }
      this.loader = false;
    },

    async renderChart(data) {
      if (data.series.length > 0) {
        const max = data.series.reduce((a, b) => Math.max(a, b));

        this.chartOptions = {
          title: {
            align: 'left',
            text: this.isPanel
              ? ''
              : `${this.$t('reports.answerEvolution.reportTitle')} ${
                  this.legend
                }`,
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: this.isPanel ? this.dataGraph.graph : this.type,
            height: this.isPanel ? this.dataGraph.layout.h * 20 : '',
            borderColor: 'rgba(0, 0, 0, 0.09)',
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
          xAxis: {
            categories: data.categories,
            visible: true,
            labels: {},
          },
          yAxis: {
            gridLineWidth: 0,
            labels: {
              enabled: false,
            },
            max,
            title: {
              text: '',
            },
            stackLabels: {
              enabled: true,
              fontWeight: 'bold',
            },
          },
          series: [
            {
              name: `${this.$t('reports.answersLabel')}`,
              data: data.series,
            },
          ],
          legend: {
            enabled: false,
          },
          plotOptions: {
            column: {
              pointPadding: 0.1,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
              },
            },
            line: {
              dataLabels: {
                enabled: true,
              },
            },
            area: {
              dataLabels: {
                enabled: true,
              },
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              borderWidth: 0,
            },
          },
          colors: ['#4ce595'],
        };
      }
    },
    getLegend() {
      switch (this.reportType) {
        case 'day':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accDailyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.dailyLabel')}`;
          }
          break;
        case 'week':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accWeeklyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.weeklyLabel')}`;
          }
          break;
        case 'month':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accMonthlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.monthlyLabel')}`;
          }
          break;
        case 'quarter':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accQuarterlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.quarterlyLabel')}`;
          }
          break;
        default:
          break;
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.getLegend();
  },

  async mounted() {

    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;
      await this.setColumnCard(this.dataGraph);
      this.type = 'column';
      this.loader = false;
    } else {
      await this.prepareChart();
      eventBus.$on('accumulated-report', (checked) => {
        this.accumulated = checked;
        switch (this.accumulated) {
          case true:
            this.renderChart({
              categories: this.answersEvolution.categories,
              series: this.answersEvolution.seriesAccumulated,
            });
            break;
          case false:
            this.renderChart({
              categories: this.answersEvolution.categories,
              series: this.answersEvolution.series,
            });
            break;
          default:
            this.legend = ' ';
        }
      });
      eventBus.$on('data-source', (checked) => {
        this.reportType = checked;
        this.prepareChart();
      });
      eventBus.$on('switch-chart', (chart) => {
        this.type = chart;
        this.loader = true;
        if (this.accumulated) {
          this.renderChart({
            categories: this.answersEvolution.categories,
            series: this.answersEvolution.seriesAccumulated,
          });
        } else {
          this.renderChart({
            categories: this.answersEvolution.categories,
            series: this.answersEvolution.series,
          });
        }
        this.loader = false;
      });
    }
    this.loader = false;
  },
  beforeDestroy() {
    eventBus.$off('switch-chart');
    eventBus.$off('data-source');
    eventBus.$off('accumulated-report');
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 100%;
  height: 200px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.start-page{margin-top: 5rem;}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/answer-evolution.vue